import { createSlice } from '@reduxjs/toolkit';

const commonState = {
    filter: {
        page: 1,
        size: 20,
    },
    cursor: 0,
};

const initialState = {
    organization: {
        ...commonState,
    },

    organizationMerge: {
        ...commonState,
    },
};

const organizationSlice = createSlice({
    name: 'organization',
    initialState,
    reducers: {
        setOrganizationFilter: (state, action) => void (state.organization.filter = action.payload),
        setOrganizationCursor: (state, action) => void (state.organization.cursor = action.payload),

        setOrganizationMergeFilter: (state, action) => void (state.organizationMerge.filter = action.payload),
        setOrganizationMergeCursor: (state, action) => void (state.organizationMerge.cursor = action.payload),
    },
});

export const organizationSliceActions = organizationSlice.actions;

export default organizationSlice;
